import FetchService from "./Shared/FetchService";
const BASE_URL = "/aviso/addressType";
export default class AddressTypeService {
    static search(search, options = {}) {
        return FetchService.getPagedResponse(BASE_URL + "/search", {
            searchText: search.searchText,
            max: options.max,
            offset: options.offset,
            sort: options.sort,
            order: options.order,
        });
    }
}
